package fr.frux.feature.treeadd.wizard

/** « a, b et c » : [and] est le mot de liaison localisé, le dernier élément le suit seul. */
fun joinLost(
    parts: List<String>,
    and: String,
): String =
    when (parts.size) {
        0 -> ""
        1 -> parts.first()
        else -> parts.dropLast(1).joinToString(", ") + " $and " + parts.last()
    }
